<template>
    <div class="content-wrapper app-listing-page">
        <div class="row align-items-start mb-4">
            <div class="col-lg-8">
                <app-breadcrumb :page-title="$t('employees')" :icon="'grid'" />
                <p class="app-listing-page__intro text-muted mb-0">
                    {{ $t('employees_page_intro') }}
                </p>
            </div>
            <div class="col-lg-4 mt-3 mt-lg-0">
                <div class="app-listing-page__top-actions">
                    <button
                        v-if="this.$can('store_employees')"
                        type="button"
                        class="btn btn-primary btn-with-shadow"
                        data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('new-employee') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="refreshTable"
                    >
                        {{ this.$t('refresh') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="card card-with-shadow border-0 mb-4">
            <div class="card-body app-listing-page__table-card-body">
                <app-table :id="tableId" :options="options" @action="getListAction" />
            </div>
        </div>

        <employee-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="employee-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';
import AppFunction from '../../../../core/helpers/app/AppFunction';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppEmployees",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'employees-table',
            rowData: {},
            options: {
                name: 'AppEmployees',
                url: actions.EMPLOYEE,
                showHeader: true,
                tableShadow: false,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    // {
                    //     title: this.$t('#'),
                    //     type: 'text',
                    //     key: 'id',
                    // },
                    {
                        title: this.$t('Photo'),
                        type: 'media-object',
                        key: 'photo',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return row.photo_url || value || AppFunction.getAppUrl('images/avatar-demo.jpg');
                        },
                        isVisible: true
                    },
                    {
                        title: this.$t('name'),
                        type: 'custom-html',
                        modifier: (value, row) => {
                            return `<span>${row.last_name} ${row.middle_name} ${row.first_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('matricule'),
                        type: 'text',
                        key: 'matricule',
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        modifier: (value, row) => {
                            if(value == 'active') {
                                return `<span class="badge rounded-pill badge-success">${this.$t(value)}</span>`;
                            } else if (value == 'suspended') {
                                return `<span class="badge rounded-pill badge-warning">${this.$t(value)}</span>`;
                            } else {
                                return `<span class="badge rounded-pill badge-danger">${this.$t(value)}</span>`
                            }
                        }
                    },
                    {
                        title: `${this.$t('shift')} & ${this.$t('worksite')}`,
                        type: 'custom-html',
                        key: 'default_shift_name',
                        modifier: (value, row) => this.renderAssignmentColumn(row),
                    },
                    {
                        title: this.$t('phone'),
                        type: 'text',
                        key: 'phone',
                    },
                    
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'employee-add-modal',
                        modalId: 'employee-add-edit-modal',
                        modifier: () => this.$can('update_employees'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_employees'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        renderAssignmentColumn(row) {
            const shift = row.default_shift_name || this.$t('not_available');
            const worksite = row.default_location_name || this.$t('unassigned_location');

            return `
                <div class="employee-listing-assignment">
                        <span class="employee-listing-assignment__value">${shift}</span>
                        <span class="employee-listing-assignment__value">${worksite}</span>
                </div>
            `;
        },
        refreshTable() {
            this.$hub.$emit('reload-' + this.tableId);
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#employee-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.EMPLOYEE}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.EMPLOYEE}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#employee-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>

<style lang="scss">
.employee-listing-assignment {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    min-width: 12rem;
}

.employee-listing-assignment__item {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    padding: 0.55rem 0.7rem;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 0.8rem;
    background: rgba(248, 250, 252, 0.95);
}

.employee-listing-assignment__label {
    font-size: 0.69rem;
    line-height: 1.1;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    font-weight: 700;
    color: #94a3b8;
}

.employee-listing-assignment__value {
    font-size: 0.9rem;
    line-height: 1.35;
    font-weight: 600;
    color: #334155;
    word-break: break-word;
}
</style>
